import { render } from "./ModalSection.vue?vue&type=template&id=6a2fba9e&ts=true&lang=pug"
import script from "./ModalSection.vue?vue&type=script&lang=ts"
export * from "./ModalSection.vue?vue&type=script&lang=ts"

import "./ModalSection.vue?vue&type=style&index=0&id=6a2fba9e&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__